import { useCookies } from 'react-cookie';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';

/**
 * Protects routes by admin role.
 * - admin 0: no access, redirect to /
 * - admin 1: full access
 * - admin 2: only allowedRoles [1,2] (e.g. Careers); else redirect to /careers
 * @param {React.ReactNode} children
 * @param {number[]} allowedRoles - e.g. [1] for admin-only, [1,2] for admin + career manager
 */
function ProtectedRoute({ children, allowedRoles }) {
    const [cookies] = useCookies(['admin']);
    const history = useHistory();

    const admin = cookies.admin !== undefined && cookies.admin !== '' ? Number(cookies.admin) : null;

    useEffect(() => {
        if (admin === null || admin === 0) {
            history.replace('/');
            return;
        }
        if (allowedRoles && !allowedRoles.includes(admin)) {
            history.replace('/careers');
        }
    }, [admin, allowedRoles, history]);

    if (admin === null || admin === 0) return null;
    if (allowedRoles && !allowedRoles.includes(admin)) return null;
    return children;
}

export default ProtectedRoute;
